import "react-app-polyfill/ie9"; // For IE 9-11 support
import "react-app-polyfill/stable";
// import 'react-app-polyfill/ie11'; // For IE 11 support
import "./polyfill";
import React from "react";
import ReactDOM from "react-dom";
import { legacy_createStore as createStore} from 'redux'
import { reducers } from "./Redux/reducers/index";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import "moment/locale/fa";
import '../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';


import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  createHttpLink,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

import * as serviceWorker from "./sw";
import { QueryCache, ReactQueryCacheProvider } from "react-query";

import { initDB, IndexedDB } from "react-indexed-db";
import { DBConfig } from "./indexedDB_config";
import { GraphUrl } from "./Controllers/rest_api_config";
import Cookies from "js-cookie";

import { Notifications } from "react-push-notification";
import { subscribeUser } from "./subscription";



export const APP_VERSION = "1.3.9"

// Store is a global state storage. We can callback the any states in the store in the all of Components.
const store = createStore(
  reducers
  // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

// Dispatch : به معنای اعزام کردن مثل فرستادن یک state و یا action به store
// Dispatch is sending request to store with reducer.
// store.subscribe(() => console.log(store.getState()));

const queryCache = new QueryCache({
  defaultConfig: {
    queries: {
      refetchOnWindowFocus: true,
    },
  },
});

initDB(DBConfig);

const httpLink = createHttpLink({
  uri: GraphUrl,
});

const authLink = setContext(async(_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token =await Cookies.get("token");
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

ReactDOM.render(
  <Provider store={store}>
    <ApolloProvider client={client}>
      <ReactQueryCacheProvider queryCache={queryCache}>
        <IndexedDB
          name="DHOHA_POWER"
          version={1.28}
          objectStoresMeta={[
            {
              store: "add_fact",
              storeConfig: { keyPath: "id", autoIncrement: true },
              storeSchema: [
                {
                  name: "facts_info",
                  keypath: "facts_info",
                  options: { unique: false },
                },
              ],
            },
          ]}
        >
          <App />
          <Notifications />
        </IndexedDB>
      </ReactQueryCacheProvider>
    </ApolloProvider>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register({
  onUpdate: registration => {
    const waitingServiceWorker = registration.waiting
    
    if (waitingServiceWorker) {
      waitingServiceWorker.addEventListener("statechange", event => {
        if (event.target.state === "activated") {
          window.location.reload()
        }
      });
      waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
    }
  },
});
subscribeUser();